/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);

const $shareWeb = $el.find('.share-web');
const $twitter  = $el.find('.share-twitter');
const $facebook = $el.find('.share-facebook');
const $whatsapp = $el.find('.share-whatsapp');


$shareWeb.on('click', function(e) {
    const $this = $(this);

    let clipboard = new ClipboardJS('.share-web', {
        text: function(el) {
            return window.location.href;
        }
    });

    let timeout;

    clipboard.on('success', function(e) {
        $this.addClass('show-success');

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            $this.removeClass('show-success');
            clipboard.destroy();
        }, 2000);
    });
});

$twitter.on('click', function() {
    Share.twitter(window.location.href, '');

    return false;
});

$facebook.on('click', function() {
    Share.facebook(window.location.href);

    return false;
});

$whatsapp.on('click', function() {
    Share.whatsapp(window.location.href);

    return false;
});
